// extracted by mini-css-extract-plugin
export default {"shadowedContainer":"_7x5g1LyE5Rh2vJfIaBmUk _1L4Ij7XUwZV5uYkPRFBO5O"};